import { type FC } from "react";
import { Grid } from "semantic-ui-react";

import { ValidatedForm } from "../../../../../components";
import { type PackRequestFormFieldProps } from "./types";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { withUSFormattedNumberInput } from "components/forms/USFormattedNumberInput/USFormattedNumberInput";

const USFormattedInputField = withUSFormattedNumberInput(ValidatedForm.InputField);

export const LicensesCountField: FC<PackRequestFormFieldProps> = ({
  values,
  onIsValidChange,
  handleChange,
  setFieldValue,
  ...props
}) => {
  const showPaidPacks = !!useFeatureFlag(FeatureFlags.PaidPacks);

  return (
    <Grid.Row>
      <Grid.Column>
        <USFormattedInputField
          label={showPaidPacks ? "Number of Users" : "How Many Licenses?"}
          value={values.licensesCount}
          propertyName="licensesCount"
          errorPosition="top"
          markAsRequired={showPaidPacks}
          onIsFormValidChange={onIsValidChange}
          placeholder={showPaidPacks ? "Enter Number of Users" : "Enter Number of Licenses"}
          {...props}
          onValueChanged={(data) => {
            setFieldValue("licensesCount", data.value);
          }}
          testId="licenses-count-input"
        />
      </Grid.Column>
    </Grid.Row>
  );
};
